import React, { Component } from "react";
import { Row } from "react-bootstrap";

class InferenceOff extends Component {
  render() {
    let mTop
    if (this.props.deviceType === "DESKTOP") {
      mTop = "247px";
    } else {
      mTop = "25%";
    }
    return (
      <div
        style={{
          //marginLeft: "59px",
          marginTop: mTop,
          borderWidth: "1px",
          borderStyle: "solid",
          background: "#2E3A53",
          width: "390px",
          boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
          borderRadius: "9px"
        }}
      >
        <Row>
          <div
            style={{ color: "#C2C0BD", marginLeft: "48px", marginTop: "20px" }}
          >
            Preview
          </div>
        </Row>
        <Row>
          <div>
            <center>
              <p
                style={{
                  width: "318px",
                  height: "0px",
                  marginTop: "21px",
                  color: "#C2C0BD",
                  borderStyle: "solid",
                  borderWidth: "0.5px"
                }}
              />
            </center>
          </div>
        </Row>
        <Row>
          <div
            style={{
              color: "#C2C0BD",
              marginTop: "20px",
              fontSize: "12px",
              width: "318px",
              marginLeft: "52px",
              marginBottom: "45px"
            }}
          >
            You must train a model on the left before you can preview it here.
          </div>
        </Row>
      </div>
    );
  }
}

export default InferenceOff;
